export const PHONE = "+91 9916161865";
export const WHATSAPP = "919916161865";
export const INSTAGRAM = "spunkyscissors";
export const ADDRESS = "602, 3rd B Cross, 2nd Block, HRBR Layout, Kalyan Nagar, Bangalore – 560043";

export const IMAGES = {
  heroOrnate: "https://images.unsplash.com/photo-1785441513757-56bba752353d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBzYWxvbiUyMGludGVyaW9yfGVufDB8fHx8MTc4NTk5NjMxMXww&ixlib=rb-4.1.0&q=85",
  salon1: "https://images.unsplash.com/photo-1600948836101-f9ffda59d250?crop=entropy&cs=srgb&fm=jpg&q=85",
  salon2: "https://images.unsplash.com/photo-1521590832167-7bcbfaa6381f?crop=entropy&cs=srgb&fm=jpg&q=85",
  hair1: "https://images.unsplash.com/photo-1580618672591-eb180b1a973f?crop=entropy&cs=srgb&fm=jpg&q=85",
  hair2: "https://images.unsplash.com/photo-1560869713-7d0a29430803?crop=entropy&cs=srgb&fm=jpg&q=85",
  hairBlow: "https://images.pexels.com/photos/14615063/pexels-photo-14615063.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  hairUpdo: "https://images.pexels.com/photos/15507425/pexels-photo-15507425.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  bridal1: "https://images.unsplash.com/photo-1756483560049-e7b2208f99a0?crop=entropy&cs=srgb&fm=jpg&q=85",
  bridal2: "https://images.unsplash.com/photo-1760461805697-7aff3e93c5d9?crop=entropy&cs=srgb&fm=jpg&q=85",
  bridal3: "https://images.unsplash.com/photo-1759720888181-7b56230250d0?crop=entropy&cs=srgb&fm=jpg&q=85",
  bridal4: "https://images.unsplash.com/photo-1770908958896-4f3b8961e2c1?crop=entropy&cs=srgb&fm=jpg&q=85",
  nail1: "https://images.unsplash.com/photo-1604654894611-6973b376cbde?crop=entropy&cs=srgb&fm=jpg&q=85",
  nail2: "https://images.unsplash.com/photo-1720343409646-960f6dcccae3?crop=entropy&cs=srgb&fm=jpg&q=85",
  nail3: "https://images.unsplash.com/photo-1588015810531-dd522c9c8bbb?crop=entropy&cs=srgb&fm=jpg&q=85",
  skin1: "https://images.unsplash.com/photo-1616394584738-fc6e612e71b9?crop=entropy&cs=srgb&fm=jpg&q=85",
  skin2: "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?crop=entropy&cs=srgb&fm=jpg&q=85",
  skin3: "https://images.unsplash.com/photo-1643684391140-c5056cfd3436?crop=entropy&cs=srgb&fm=jpg&q=85",
  academy: "https://images.unsplash.com/photo-1774660810725-fb04e002003d?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Bridal Studio", to: "/bridal" },
  { label: "Academy", to: "/academy" },
  { label: "Gallery", to: "/gallery" },
  { label: "Testimonials", to: "/testimonials" },
  { label: "Contact", to: "/contact" },
];

export const COUNTERS = [
  { value: "5000+", label: "Happy Clients" },
  { value: "1000+", label: "Students Trained" },
  { value: "10+", label: "Professional Courses" },
  { value: "5★", label: "Client Reviews" },
];

export const CATEGORIES = [
  { title: "Hair", img: IMAGES.hair1, desc: "Cuts, color, keratin & transformations" },
  { title: "Beauty", img: IMAGES.skin2, desc: "Facials, cleanups & grooming rituals" },
  { title: "Skin", img: IMAGES.skin1, desc: "Advanced dermal & anti-aging care" },
  { title: "Nails", img: IMAGES.nail1, desc: "Gel, acrylic & luxury nail art" },
  { title: "Bridal", img: IMAGES.bridal1, desc: "HD, airbrush & signature bridal looks" },
  { title: "Academy", img: IMAGES.academy, desc: "Certified professional beauty education" },
];

export const SERVICE_GROUPS = [
  {
    id: "hair", name: "Hair Services", img: IMAGES.hair2, duration: "45 min – 4 hrs",
    desc: "From precision cuts to gloss-rich color and repair rituals, our master stylists craft hair that moves with confidence.",
    items: ["Hair Cut", "Hair Styling", "Hair Wash", "Hair Color", "Global Color", "Highlights", "Balayage", "Ombre", "Keratin", "Smoothening", "Hair Botox", "Nano Botox", "Hair Spa", "Hair Rebonding", "Hair Extensions", "Scalp Treatments", "Hair Fall Solutions"],
  },
  {
    id: "skin", name: "Skin Services", img: IMAGES.skin1, duration: "45 – 90 min",
    desc: "Clinically-inspired facials and dermal therapies that restore radiance, texture and youthful glow.",
    items: ["Hydra Facial", "Gold Facial", "Acne Facial", "Detan Facial", "Brightening Facial", "Anti-Aging Facial", "Skin Polishing", "Advanced Skin Treatments"],
  },
  {
    id: "grooming", name: "Grooming & Spa", img: IMAGES.skin3, duration: "30 – 90 min",
    desc: "Refined waxing, threading and indulgent spa rituals for a polished, groomed you.",
    items: ["Waxing", "Threading", "Pedicure", "Manicure", "Luxury Spa Services"],
  },
  {
    id: "nails", name: "Nail Services", img: IMAGES.nail2, duration: "45 – 120 min",
    desc: "Statement nails engineered to last — from chrome finishes to intricate hand-painted art.",
    items: ["Gel Nails", "Acrylic Nails", "French Extensions", "Nail Extensions", "Chrome Nails", "Bridal Nails", "Luxury Nail Art", "Nail Refill"],
  },
];

export const BRIDAL_LOOKS = ["HD Makeup", "Airbrush Makeup", "Bridal Makeup", "Nikah Makeup", "Reception Makeup", "Engagement Makeup", "Party Makeup", "Editorial Makeup", "Fashion Makeup", "Photoshoot Makeup"];

export const BRIDAL_PACKAGES = [
  { name: "Silver Bridal", tag: "The Essential", points: ["HD Party Makeup", "Hair Styling", "Draping", "Basic Nails", "Trial Session"] },
  { name: "Gold Bridal", tag: "Most Loved", points: ["HD/Airbrush Makeup", "Signature Hairdo", "Saree/Lehenga Draping", "Gel Nails", "Pre-bridal Facial", "Trial Session"] },
  { name: "Platinum Bridal", tag: "Premium", points: ["Airbrush + HD Makeup", "Advanced Hair Artistry", "Designer Draping", "Luxury Nail Art", "Full Pre-bridal Package", "Family Makeup (2)"], featured: true },
  { name: "Royal Signature", tag: "The Ultimate", points: ["Celebrity Airbrush Makeup", "Bespoke Hair Couture", "Premium Draping", "Bridal Nail Art", "Complete Pre-bridal", "Family Makeup (4)", "Dedicated Artist Team"], royal: true },
];

export const COURSES = [
  { id: "makeup", name: "Professional Makeup Course", duration: "3 Months", fee: "On Enquiry", img: IMAGES.bridal2,
    modules: ["Basic Makeup", "Advanced Makeup", "HD Makeup", "Airbrush Makeup", "Bridal Makeup", "Editorial Makeup", "Color Theory", "Face Shapes", "Portfolio Building", "Photography", "Social Media Marketing", "Client Handling", "Business Setup", "Certification"] },
  { id: "hair", name: "Professional Hair Course", duration: "3 Months", fee: "On Enquiry", img: IMAGES.hair1,
    modules: ["Hair Science", "Hair Cutting", "Hair Styling", "Hair Coloring", "Highlights", "Global Coloring", "Keratin", "Smoothening", "Hair Botox", "Salon Management", "Business Setup", "Certification"] },
  { id: "nail", name: "Professional Nail Course", duration: "6 Weeks", fee: "On Enquiry", img: IMAGES.nail2,
    modules: ["Gel Nails", "Acrylic Nails", "Nail Extensions", "Nail Art", "Advanced Designs", "Client Consultation", "Salon Hygiene", "Business Setup", "Certification"] },
  { id: "beauty", name: "Professional Beauty Course", duration: "2 Months", fee: "On Enquiry", img: IMAGES.skin2,
    modules: ["Skin Science", "Facials", "Waxing", "Threading", "Cleanups", "Advanced Beauty Treatments", "Salon Management", "Certification"] },
];

export const ACADEMY_PERKS = ["Government-recognised Certification", "Easy EMI Options", "Placement Assistance", "Internship Support", "Hands-on Kit & Training", "Lifetime Alumni Community"];

export const TESTIMONIALS = [
  { name: "Ayesha Khan", role: "Bride", text: "My wedding look was beyond a dream. The airbrush makeup lasted through 12 hours of celebration and every photo was flawless." },
  { name: "Priya Nair", role: "Academy Graduate", text: "The makeup course changed my life. I now run my own studio with 20+ bridal bookings a month. The placement support was real." },
  { name: "Sneha Reddy", role: "Regular Client", text: "Best keratin and hair spa in Kalyan Nagar. The ambience feels like a 5-star hotel and the stylists truly listen." },
  { name: "Farhan Ali", role: "Client", text: "Finally a unisex salon that gets men's grooming right. Precise cuts, great products, zero rush." },
  { name: "Divya Menon", role: "Nail Course Student", text: "Learnt gel, acrylic and chrome art from scratch. Certification helped me land a job within two weeks of finishing." },
  { name: "Ritika Shah", role: "Bride", text: "The Royal Signature package was worth every rupee. Dedicated artist team, pre-bridal care — I felt like a celebrity." },
];

export const SUCCESS_STATS = [
  { value: "1000+", label: "Students Trained" },
  { value: "500+", label: "Successful Placements" },
  { value: "95%", label: "Satisfaction Rate" },
  { value: "100+", label: "Business Owners Trained" },
];

export const GALLERY = [
  { img: IMAGES.hairUpdo, cat: "Hair Transformations" },
  { img: IMAGES.bridal1, cat: "Bridal Makeup" },
  { img: IMAGES.nail3, cat: "Nail Art" },
  { img: IMAGES.hair1, cat: "Hair Colors" },
  { img: IMAGES.skin3, cat: "Skin Treatments" },
  { img: IMAGES.salon1, cat: "Salon Interiors" },
  { img: IMAGES.bridal3, cat: "Bridal Makeup" },
  { img: IMAGES.academy, cat: "Academy Training" },
  { img: IMAGES.nail1, cat: "Nail Art" },
  { img: IMAGES.bridal4, cat: "Student Work" },
  { img: IMAGES.hair2, cat: "Hair Transformations" },
  { img: IMAGES.skin1, cat: "Skin Treatments" },
];
export const GALLERY_CATS = ["All", "Hair Transformations", "Hair Colors", "Bridal Makeup", "Nail Art", "Skin Treatments", "Salon Interiors", "Academy Training", "Student Work"];
